import React, { useState, useRef, useEffect } from 'react';
import SEO from '../components/SEO';
import { FaCloudDownloadAlt, FaGoogleDrive, FaFilm } from "react-icons/fa";
import { FiSend } from "react-icons/fi";
import { GrMicrophone } from "react-icons/gr";
import { MdAttachFile } from "react-icons/md";
import { PiFolderSimpleLight } from "react-icons/pi";
import { useNavigate } from 'react-router-dom';
import SubNav from "../components/subNav";
import styles from '../styles/script.module.css';
import { baseUrl } from '../config';



const VintageParchment = ({ children }) => {
    const [inputValue, setInputValue] = useState('');
    const [projectTitle, setProjectTitle] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [uploadStatus, setUploadStatus] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const fileInputRef = useRef(null);
    const navigate = useNavigate();
    const [activeUser, setActiveUser] = useState();
    const [activeProjects, setActiveProjects] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const shortFilmRef = useRef(null);
    const AdvertisementRef = useRef(null);
    const fullFilmRef = useRef(null);
    const [titleInp, setTitleInp] = useState("");
    const [descriptionInp, setDescriptionInp] = useState("");
    const [filmTypeInp, setFilmTypeInp] = useState(1);
    const [genreInp, setGenreInp] = useState("");
    const projectTypeArr = ["short", "full", "advertisement"];
    const [projectId, setProjectId] = useState(0);
  
    /* On Load functions*/
  
    useEffect(() => {
      setActiveProjects([]);
      getUsersActiveProjects();
    },[]);
    
    /* create project label click function */
  
    function handleLabelClick(radio){
      /* set film type usestate */
  
      setFilmTypeInp(radio);
      
      /* clear background color */
  
      shortFilmRef.current.style.backgroundColor = "white";
      shortFilmRef.current.style.color = "black";
      fullFilmRef.current.style.backgroundColor = "white";
      fullFilmRef.current.style.color = "black";
      AdvertisementRef.current.style.backgroundColor = "white";
      AdvertisementRef.current.style.color = "black";
  
      /* re-add hover effects */
  
      shortFilmRef.current.addEventListener('mouseover', function(){
        shortFilmRef.current.style.backgroundColor = "var(--hover-color)";
        shortFilmRef.current.style.color = "white";
      })
      shortFilmRef.current.addEventListener('mouseout', function(){
        shortFilmRef.current.style.backgroundColor = "white";
        shortFilmRef.current.style.color = "black";
      })
      fullFilmRef.current.addEventListener('mouseover', function(){
        fullFilmRef.current.style.backgroundColor = "var(--hover-color)";
        fullFilmRef.current.style.color = "white";
      })
      fullFilmRef.current.addEventListener('mouseout', function(){
        fullFilmRef.current.style.backgroundColor = "white";
        fullFilmRef.current.style.color = "black";
      })
      AdvertisementRef.current.addEventListener('mouseover', function(){
        AdvertisementRef.current.style.backgroundColor = "var(--hover-color)";
        AdvertisementRef.current.style.color = "white";
      })
      AdvertisementRef.current.addEventListener('mouseout', function(){
        AdvertisementRef.current.style.backgroundColor = "white";
        AdvertisementRef.current.style.color = "black";
      })
  
      /* conditionally set active button */
  
      switch (radio) {
        case 1:
          shortFilmRef.current.style.backgroundColor = "var(--accent-color)";
          shortFilmRef.current.style.color = "white";
          shortFilmRef.current.addEventListener('mouseout', function(){
            shortFilmRef.current.style.backgroundColor = "var(--accent-color)";
            shortFilmRef.current.style.color = "white";
          })
          break;
        case 2:
          fullFilmRef.current.style.backgroundColor = "var(--accent-color)";
          fullFilmRef.current.style.color = "white";
          fullFilmRef.current.addEventListener('mouseout', function(){
            fullFilmRef.current.style.backgroundColor = "var(--accent-color)";
            fullFilmRef.current.style.color = "white";
          })    
          break;
        case 3:
          AdvertisementRef.current.style.backgroundColor = "var(--accent-color)";
          AdvertisementRef.current.style.color = "white";
          AdvertisementRef.current.addEventListener('mouseout', function(){
            AdvertisementRef.current.style.backgroundColor = "var(--accent-color)";
            AdvertisementRef.current.style.color = "white";
          })
          break;
        default:
          break;
      }
    }
  
    /* project create function */
  
    const handleCreateProject = async (e) => {
      e.preventDefault();
  
      /* create Project */
  
        try { 
          const createProjectRequest = await fetch(`${baseUrl}/projects`, {
              method: "POST",  
              headers : {"Content-Type": "application/json"},
              body : JSON.stringify({
                title: titleInp,
                project_desc: descriptionInp,
                project_type: projectTypeArr[filmTypeInp],
                genre: genreInp,
                creator_id: activeUser
              }),  
          }); 
          if (createProjectRequest.ok) {
            const project = await createProjectRequest.json();
            setProjectId(project.id);
            const addMemberRequest = await fetch(`${baseUrl}/addProjectMember`, {
              method: "POST",
              headers : {"Content-Type": "application/json"},
              body : JSON.stringify({
                user_id: activeUser,
                project_id: project.id
              })
            });
            if (addMemberRequest.ok) {
            }
            else{
            }
          }
          else{
            console.error("Project creation Failed")
          }
        }
        catch{}
  
        /* update active projects list */
  
        setActiveProjects([]);
        getUsersActiveProjects(); 
        
        setActivePage(3);
    }
  
    /* page display function */
  
    const renderPage = () => {
      switch (activePage) {
        case 1: /* landing page (pick your project/start your project) */
          return(
            <div id={styles.projectSelector}>
              <h1 id={styles.welcomeMessage}>Welcome to the Script Analysis Tool!</h1>
              <p id={styles.toolDesc}>This tool will help you create or upload your script, modify it and more! Its like having a writing team in the palm of your hand.</p>
              {activeProjects.length !== 0 && <div id={styles.projectSelectorGrid}>
                <div id={styles.activeProjContainer}>
                  <div id={styles.innerContainer}>
                    <h2 id={styles.selectAProject}>Select an existing Project</h2>
                    <div id={styles.projectList}>{ProjectList}</div>
                  </div>
                </div>
                <p id={styles.projectSelectOr}>Or...</p>
                <div id={styles.newProjectContainer}>
                  <button id={styles.newProjectButton} onClick={() => {setActivePage(2)}}>Start a new project here!</button>
                </div>
              </div>}
              {activeProjects.length === 0 && <div id={styles.projectStarter}>
                <div id={styles.newProjectContainer}>
                  <button id={styles.newProjectButton}>Start a new project here!</button>
                </div>
              </div>}
            </div>
          );
      
        case 2: /* project creation page */
          return(
            <div id={styles.projectCreator}>
              <button className={styles.backButton} onClick={() => {setActivePage(1)}}>Back</button>
              <h2 id={styles.createProjectHeading}>Create a project</h2>
              <p className={styles.pageDetails}>This screen is used to create a project. Each input is optional and can be changed later.</p>
              <form id={styles.projectCreationForm} onSubmit={handleCreateProject}>
                <label htmlFor="title">Project Title</label>
                <input type="text" name="title" id={styles.titleInp} onChange={(e) => {setTitleInp(e.target.value)}}/>
                <label htmlFor="description">Project Description</label>
                <textarea name="description" id={styles.projectDesc} cols="30" rows="2" onChange={(e) => {setDescriptionInp(e.target.value)}}></textarea>
                <label>Film Type</label>
                <div id={styles.radioSelectFilmType}>
                  <label for={styles.shortFilmRadio} ref={shortFilmRef} onClick={() => {handleLabelClick(1)}}><input type="radio" name="FilmType" id={styles.shortFilmRadio}/>
                  <span className={styles.filmTypeTitle}>Short Film</span><span className={styles.filmTypeDesc}>Short films are generally 40 minutes or less.</span></label>
                  <label for={styles.fullFilmRadio} ref={fullFilmRef} onClick={() => {handleLabelClick(2)}}><input type="radio" name="FilmType" id={styles.fullFilmRadio} />
                  <span className={styles.filmTypeTitle}>Full Length Film</span><span className={styles.filmTypeDesc}>Full length films are generally longer than 40 minutes.</span></label>
                  <label for={styles.advertisementFilmRadio} ref={AdvertisementRef} onClick={() => {handleLabelClick(3)}}><input type="radio" name="FilmType" id={styles.advertisementFilmRadio} />
                  <span className={styles.filmTypeTitle}>Advertisement</span><span className={styles.filmTypeDesc}>Advertisements are typically less than 3 minutes in length.</span></label>
                </div>
                <label htmlFor="genre">Genre</label>
                <input type="text" name="gener" id={styles.genreInp} onChange={(e) => {setGenreInp(e.target.value)}}/>
                <div id={styles.submitForm}>
                  <button type='submit' id={styles.createButton}>Create Project!</button>
                  <p>Or...</p>
                  <button type='submit' id={styles.skipButton} >Skip</button>
                </div>
              </form>
            </div>
          );
  
        case 3: /* prompt input */
        return (
          <div id={styles.promptInput}>
            <button className={styles.backButton} onClick={() => {setActivePage(1)}}>Back</button>
            <div className="text-center">
              <h2 className="text-amber-500 text-2xl font-bold mb-4">Enter your thoughts, and let the magic begin...</h2>
            </div>
            <div>
              <div className={styles.scriptPromptInput}>
                <input
                  type="text"
                  className="custom-input-field"
                  placeholder="Enter your thoughts and script details or requirements..."
                  value={inputValue}
                  onChange={handleInputChange}
                />
                <div className={styles.scriptPromptInputButtons}>
                  <GrMicrophone className={styles.scriptPromptInputButton} />
                  <MdAttachFile className={styles.scriptPromptInputButton}  />
                  <FiSend className={styles.scriptPromptInputButton}  onClick={handleSendClick} />
                </div>
              </div>
            </div>
            {showAlert && (
              <div className={`mb-6 p-4 rounded-lg text-center ${alertType === 'error'
                ? 'bg-red-100 text-red-700 border border-red-300'
                : 'bg-green-100 text-green-700 border border-green-300'
                }`}>
                {alertMessage}
              </div>
            )}
            <div className="text-center">
                <h5 className="text-xl text-amber-500 mb-6 font-bold">Upload Existing Script</h5>
                <input
                  type="file"
                  ref={fileInputRef}
                  className={styles.uploadScriptInp}
                  accept=".txt,.pdf,.doc,.docx"
                  onChange={(e) => handleFileUpload(e.target.files?.[0])}
                />
            </div>
            <div className={styles.uploadSelector}>
                    <button
                      className="px-6 py-3 bg-gray-100 text-amber-500 rounded-lg border border-amber-500 hover:bg-amber-500 hover:text-gray-900 transition-all duration-300 flex items-center space-x-2"
                      onClick={handleDeviceUpload}
                      disabled={uploadStatus === 'uploading'}
                    >
                      <PiFolderSimpleLight className="text-xl" />
                      <span>Your Device</span>
                    </button>
  
                    <button
                      className="px-6 py-3 bg-gray-100 text-amber-500 rounded-lg border border-amber-500 hover:bg-amber-500 hover:text-gray-900 transition-all duration-300 flex items-center space-x-2"
                      onClick={handleGoogleDriveUpload}
                    >
                      <FaGoogleDrive className="text-xl" />
                      <span>Google Drive</span>
                    </button>
  
                    <button
                      className="px-6 py-3 bg-gray-100 text-amber-500 rounded-lg border border-amber-500 hover:bg-amber-500 hover:text-gray-900 transition-all duration-300 flex items-center space-x-2"
                      onClick={handleCloudUpload}
                    >
                      <FaCloudDownloadAlt className="text-xl" />
                      <span>Cloud</span>
                    </button>
            </div>
          </div>
        )
  
        case 4: /* chat window */
          break;
          
        default:
          break;
      }
    }
  
    const handleInputChange = (event) => {
      setInputValue(event.target.value);
    };
  
    const handleSendClick = () => {
     
    };
  
    const handleFileUpload = async (file) => {
      if (!file) return;
      const allowedTypes = ['text/plain', 'application/pdf', 'application/msword'];
      const maxSize = 10 * 1024 * 1024;
      if (!allowedTypes.includes(file.type)) {
        showNotification('Please upload a text, PDF, or Word document', true);
        return;
      }
      if (file.size > maxSize) {
        showNotification('File size must be less than 10MB', true);
        return;
      }
      setUploadStatus('uploading');
      try {
        await new Promise(resolve => setTimeout(resolve, 1500));
        showNotification(`Successfully uploaded ${file.name}`);
        setUploadStatus('success');
        navigate('/loading', { state: { fileName: file.name } });
      } catch (error) {
        showNotification('Error uploading file. Please try again.', true);
        setUploadStatus('error');
      }
    };
  
    const handleDeviceUpload = () => {
      fileInputRef.current?.click();
    };
  
    const handleGoogleDriveUpload = () => {
      showNotification('Google Drive integration coming soon!');
    };
  
    const handleCloudUpload = () => {
      showNotification('Cloud upload integration coming soon!');
    };
  
    const showNotification = (message, isError = false) => {
      setAlertMessage(message);
      setAlertType(isError ? 'error' : 'success');
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    };
  
    /* Set active user on page */
  
    async function getUserIdByToken() {
      try {  
        const userId = await fetch(`${baseUrl}/getUserIDByToken`, {  
            headers: {  
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,  
            },  
        });  
        
        if (!userId.ok) {  
            navigate("/login");  
            return;  
        }  
        
        const id = await userId.json();  
        setActiveUser(id.user_id); 
        return id.user_id 
      }
      catch{}
    }
  
    /* Get users active projects */
  
    async function getUsersActiveProjects() {
      let userId = await getUserIdByToken();
      setActiveProjects([]);
      let projectArray = [];
      try { 
        const projectsRequest = await fetch(`${baseUrl}/getProjectsByUserId`, {  
            headers: {  
                user_id: userId,  
            },  
        });  
        const projects = await projectsRequest.json();
        for (let i = 0; i < projects.length; i++) {
          const element = projects[i];
          const projectRequest = await fetch(`${baseUrl}/getProjectById`, {  
            headers: {  
                project_id: element.project_id,  
            },
          })
          const project = await projectRequest.json();
          projectArray.push(project);
        }
        setActiveProjects([...projectArray]);
      }
        catch{}
    }
  
    /* render function for each active project a user is a part of */
  
    const ProjectList = activeProjects.map( project => 
    <button className={styles.projectButton} key={project.id} onClick={() => {
      setProjectId(project.id);
      setActivePage(3);
    }}>{project.title !== "" ? project.title : "Unnamed Project"}</button>
  )
  
  return (
    <div className="parchment-container">
      <SEO
        title="Script Editor"
        description="Write and edit your film script with ProducerBuddy's script editor tools."
        url="https://producerbuddy.pilomation.com/script-editor"
        robots="noindex, nofollow"
      />
      <style>
        {`
          .parchment-container {
            min-height: 100vh;
            background-color: #451a03;
            padding: 1rem;
          }

          @media (min-width: 768px) {
            .parchment-container {
              padding: 2rem;
            }
          }

          .parchment-wrapper {
            width: 100%;
            min-height: 100vh;
            position: relative;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .top-roll, .bottom-roll {
            position: absolute;
            left: 0;
            right: 0;
          }

          .top-roll {
            top: -1rem;
          }

          .bottom-roll {
            bottom: -1rem;
          }

          .roll-content {
            height: 7rem;
            background: linear-gradient(to bottom, #fef3c7, #fde68a, #fef3c7);
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
            position: relative;
          }

          .top-roll .roll-content {
            border-radius: 9999px 9999px 0 0;
          }

          .bottom-roll .roll-content {
            border-radius: 0 0 9999px 9999px;
            background: linear-gradient(to top, #fef3c7, #fde68a, #fef3c7);
          }

          .zigzag-top {
            display:none;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 3rem;
            background: linear-gradient(to bottom, #451a03, #78350f, transparent);
            clip-path: polygon(0 0, 8% 100%, 16% 40%, 24% 100%, 32% 50%, 40% 100%, 48% 30%, 56% 100%, 64% 40%, 72% 100%, 80% 50%, 88% 100%, 96% 40%, 100% 0);
          }

          .zigzag-bottom {
            display:none;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 3rem;
            background: linear-gradient(to top, #451a03, #78350f, transparent);
            clip-path: polygon(0 100%, 8% 0, 16% 60%, 24% 0, 32% 50%, 40% 0, 48% 70%, 56% 0, 64% 60%, 72% 0, 80% 50%, 88% 0, 96% 60%, 100% 100%);
          }

          .fade-shadow-bottom {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 4rem;
            background: linear-gradient(to bottom, rgba(92, 28, 0, 0.5), transparent);
          }

          .fade-shadow-top {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 4rem;
            background: linear-gradient(to top, rgba(92, 28, 0, 0.5), transparent);
          }

          .main-content {
            position: relative;
            margin: 5rem 1.5rem;
            background: linear-gradient(to bottom right, #fef3c7, #f5e6d3, #fde68a);
            min-height: calc(100vh - 10rem);
            border-radius: 0.5rem;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
            width:100%;
          }

          .burnt-edge {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 3rem;
          }

          .burnt-edge.left {
            left: -1.5rem;
          }

          .burnt-edge.right {
            right: -1.5rem;
          }

          .edge-content {
            height: 100%;
            width: 100%;
          }

          .burnt-edge.left .edge-content {
            background: linear-gradient(to right, #451a03, #78350f, transparent);
            clip-path: polygon(0 0, 100% 2%, 70% 8%, 100% 15%, 60% 22%, 90% 30%, 50% 38%, 100% 45%, 60% 52%, 90% 60%, 50% 68%, 100% 75%, 70% 82%, 90% 90%, 100% 98%, 0 100%);
          }

          .burnt-edge.right .edge-content {
            background: linear-gradient(to left, #451a03, #78350f, transparent);
            clip-path: polygon(0 2%, 100% 0, 100% 100%, 0 98%, 30% 90%, 10% 82%, 40% 75%, 0 68%, 50% 60%, 10% 52%, 40% 45%, 0 38%, 50% 30%, 10% 22%, 40% 15%, 30% 8%);
          }

          .content-wrapper {
            position: relative;
            min-height: 100%;
            padding: 2rem;
          }

          @media (min-width: 768px) {
            .content-wrapper {
              padding: 3rem;
            }
          }

          .dotted-overlay {
            position: absolute;
            inset: 0;
            opacity: 0.07;
            background-image: radial-gradient(#654321 1px, transparent 1px);
            background-size: 8px 8px;
          }

          .decorative-circles {
            position: absolute;
            inset: 0;
          }

          .circle {
            position: absolute;
            border-radius: 9999px;
            filter: blur(24px);
          }

          .circle-1 {
            top: 25%;
            left: 25%;
            width: 16rem;
            height: 16rem;
            background-color: rgba(120, 53, 15, 0.15);
          }

          .circle-2 {
            bottom: 33%;
            right: 33%;
            width: 24rem;
            height: 24rem;
            background-color: rgba(92, 28, 0, 0.15);
          }

          .circle-3 {
            top: 50%;
            left: 50%;
            width: 12rem;
            height: 12rem;
            background-color: rgba(69, 26, 3, 0.15);
          }

          .inner-shadow {
            position: absolute;
            inset: 0;
            border-radius: 0.5rem;
            box-shadow: inset 0 2px 4px rgba(120, 53, 15, 0.2);
          }

          .content {
            position: relative;
            z-index: 10;
          }
        `}
      </style>

      <div className="parchment-wrapper">
        {/* Top roll */}
        <div className="top-roll">
          <div className="roll-content">
            <div className="zigzag-top"></div>
            <div className="fade-shadow-bottom"></div>
          </div>
        </div>

        {/* Main content area */}
        <div className="main-content">
          {/* Left burnt edge */}
          <div className="burnt-edge left">
            <div className="edge-content"></div>
          </div>

          {renderPage()}


          {/* Right burnt edge */}
          <div className="burnt-edge right">
            <div className="edge-content"></div>
          </div>

          <div className="content-wrapper">
            <div className="dotted-overlay"></div>
            
            <div className="decorative-circles">
              <div className="circle circle-1"></div>
              <div className="circle circle-2"></div>
              <div className="circle circle-3"></div>
            </div>

            <div className="inner-shadow"></div>
            <div className="content">
              {children}
            </div>
          </div>
        </div>

        {/* Bottom roll */}
        <div className="bottom-roll">
          <div className="roll-content">
            <div className="zigzag-bottom"></div>
            <div className="fade-shadow-top"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VintageParchment;
